import resizeIframeToFitContent from '@newswebsiteapp/shared/lib/resizeIframeToFitContent'

import { newsletterIframeLoadedObservable } from './observables'

newsletterIframeLoadedObservable.subscribe((iframe) => {
  resizeIframeToFitContent(iframe)
})
